var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 15,
    viewBox: "0 0 35 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292892 8.07136C-0.0976296 7.68084 -0.0976295 7.04767 0.292893 6.65715L6.65686 0.293188C7.04738 -0.0973368 7.68054 -0.0973368 8.07107 0.293188C8.46159 0.683712 8.46159 1.31688 8.07107 1.7074L2.41422 7.36425L8.07107 13.0211C8.46159 13.4116 8.46159 14.0448 8.07107 14.4353C7.68054 14.8258 7.04738 14.8258 6.65685 14.4353L0.292892 8.07136ZM35 7.36426L35 8.36426L1 8.36425L1 7.36425L1 6.36425L35 6.36426L35 7.36426Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.7ceb044a8b67b493083fe251c037d289.svg";
export { ForwardRef as ReactComponent };